<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- ═══ MI PERFIL DE AUTOR ═══ -->
    <h3 class="mb-3">Mi Perfil de Autor</h3>

    <!-- Si ya tiene perfil -->
    <v-card v-if="myAuthor" outlined class="pa-4 mb-6">
      <v-row align="center">
        <v-col cols="auto">
          <v-avatar size="80">
            <v-img v-if="myAuthor.url_img" :src="getMyImageUrl()"></v-img>
            <v-icon v-else size="80" color="grey lighten-1">mdi-account-circle</v-icon>
          </v-avatar>
        </v-col>
        <v-col>
          <p class="subtitle-1 font-weight-bold mb-0">{{ myAuthor.display_name }}</p>
          <p class="body-2 grey--text mb-0">{{ myAuthor.specialty }}</p>
          <p class="caption grey--text">{{ myAuthor.experience }}</p>
        </v-col>
        <v-col cols="auto">
          <v-btn small color="primary" @click="openEditDialog">
            <v-icon left small>mdi-pencil</v-icon> Editar
          </v-btn>
          <v-btn small color="teal" dark class="ml-1" @click="dialogImage = true">
            <v-icon left small>mdi-camera</v-icon> Imagen
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>
      <p v-if="myAuthor.bio" class="body-2 font-italic">{{ myAuthor.bio }}</p>
    </v-card>

    <!-- Si NO tiene perfil -->
    <v-card v-else outlined class="pa-4 mb-6 text-center">
      <p class="body-2 grey--text">No estás registrado como autor todavía.</p>
      <v-btn color="teal" dark @click="openEditDialog">
        <v-icon left>mdi-account-plus</v-icon> Registrarme como autor
      </v-btn>
    </v-card>

    <!-- ═══ ASIGNACIÓN DE CATEGORÍAS ═══ -->
    <h3 class="mb-3">Asignación de Categorías por Admin</h3>
    <p class="caption grey--text mb-3">Asignar qué categorías del foro administra cada autor.</p>

    <v-simple-table v-if="admins.length">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Admin</th>
            <th>Perfil Autor</th>
            <th>Categorías asignadas</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="admin in admins" :key="admin.id">
            <td>{{ admin.name }} <span class="caption grey--text">({{ admin.email }})</span></td>
            <td>
              <v-chip v-if="admin.forum_author" small color="green lighten-4">
                <v-icon left x-small>mdi-check</v-icon> {{ admin.forum_author.display_name || admin.name }}
              </v-chip>
              <v-chip v-else small color="grey lighten-3">Sin perfil</v-chip>
            </td>
            <td>
              <v-select v-model="admin.selectedCategories" :items="categoriasConHint"
                item-text="label" item-value="id" multiple chips small-chips dense
                hide-details :disabled="!admin.forum_author"
                placeholder="Seleccionar..."></v-select>
            </td>
            <td>
              <v-btn small color="teal" dark :disabled="!admin.forum_author"
                @click="asignarCategorias(admin)">
                Guardar
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Dialog editar/crear perfil -->
    <v-dialog v-model="dialogEdit" max-width="500" persistent>
      <v-card>
        <v-card-title>{{ myAuthor ? 'Editar' : 'Crear' }} Perfil de Autor</v-card-title>
        <v-card-text>
          <v-form ref="formAuthor" v-model="validAuthor">
            <v-text-field v-model="authorForm.display_name" label="Nombre público"
              hint="Se muestra como autor en el blog" persistent-hint outlined dense></v-text-field>
            <v-textarea v-model="authorForm.bio" label="Bio / Mensaje" outlined dense
              rows="3" counter="500"></v-textarea>
            <v-text-field v-model="authorForm.experience" label="Experiencia"
              hint="Ej: 5 años en desarrollo web" persistent-hint outlined dense></v-text-field>
            <v-text-field v-model="authorForm.specialty" label="Especialidad"
              hint="Ej: Backend, Laravel, APIs" persistent-hint outlined dense></v-text-field>
            <v-text-field v-model="authorForm.social_url" label="URL red social / portfolio"
              outlined dense></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogEdit = false">Cancelar</v-btn>
          <v-btn color="teal" dark :loading="savingAuthor" @click="guardarPerfil">
            {{ myAuthor ? 'Actualizar' : 'Crear' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog subir imagen -->
    <v-dialog v-model="dialogImage" max-width="400" persistent>
      <v-card>
        <v-card-title>Cambiar imagen de autor</v-card-title>
        <v-card-text>
          <v-img v-if="myAuthor && myAuthor.url_img" :src="getMyImageUrl()"
            max-height="150" contain class="mb-3 rounded grey lighten-3"></v-img>
          <v-file-input v-model="imageFile" label="Seleccionar imagen" accept="image/*"
            prepend-icon="mdi-camera" show-size dense></v-file-input>
          <p class="caption grey--text">La imagen anterior se reemplaza automáticamente.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogImage = false">Cancelar</v-btn>
          <v-btn color="teal" dark :loading="uploadingImage" :disabled="!imageFile"
            @click="subirImagen">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumAuthorAdmin',
  data() {
    return {
      myAuthor: null,
      admins: [],
      categorias: [],
      dialogEdit: false,
      dialogImage: false,
      validAuthor: true,
      savingAuthor: false,
      uploadingImage: false,
      imageFile: null,
      authorForm: {
        display_name: '',
        bio: '',
        experience: '',
        specialty: '',
        social_url: ''
      },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.cargarMiPerfil();
    this.cargarAdmins();
    this.cargarCategorias();
  },
  computed: {
    categoriasConHint() {
      return this.categorias.map(cat => {
        // Buscar si algún admin tiene esta categoría asignada
        const assignedAdmin = this.admins.find(a =>
          a.forum_author && a.selectedCategories && a.selectedCategories.includes(cat.id)
        );
        const hint = assignedAdmin ? ' (' + assignedAdmin.name + ')' : ' (libre)';
        return {
          id: cat.id,
          name: cat.name,
          label: cat.name + hint
        };
      });
    }
  },
  methods: {
    cargarMiPerfil() {
      forumService.getAuthorMe().then(res => {
        if (res.data.exists) {
          this.myAuthor = res.data.author;
        }
      });
    },
    cargarAdmins() {
      forumService.listarAdmins().then(res => {
        this.admins = res.data.map(admin => ({
          ...admin,
          selectedCategories: (admin.assigned_categories || []).map(c => c.id)
        }));
      });
    },
    cargarCategorias() {
      forumService.listarCategorias().then(res => {
        this.categorias = res.data;
      });
    },
    getMyImageUrl() {
      if (!this.myAuthor || !this.myAuthor.url_img) return '';
      return forumService.getAuthorImageUrl(this.myAuthor.id, this.myAuthor.url_img);
    },
    openEditDialog() {
      if (this.myAuthor) {
        this.authorForm = {
          display_name: this.myAuthor.display_name || '',
          bio: this.myAuthor.bio || '',
          experience: this.myAuthor.experience || '',
          specialty: this.myAuthor.specialty || '',
          social_url: this.myAuthor.social_url || ''
        };
      } else {
        this.authorForm = { display_name: '', bio: '', experience: '', specialty: '', social_url: '' };
      }
      this.dialogEdit = true;
    },
    guardarPerfil() {
      this.savingAuthor = true;
      const action = this.myAuthor
        ? forumService.updateAuthor(this.authorForm)
        : forumService.saveAuthor(this.authorForm);

      action.then(res => {
        this.myAuthor = res.data.author;
        this.showMsg(this.myAuthor ? 'Perfil actualizado' : 'Perfil creado', 'success');
        this.dialogEdit = false;
        this.cargarAdmins(); // Refrescar lista
      }).catch(err => {
        const errors = err.response && err.response.data && err.response.data.errors;
        this.showMsg(errors ? errors.join(', ') : 'Error al guardar', 'error');
      }).finally(() => {
        this.savingAuthor = false;
      });
    },
    subirImagen() {
      if (!this.imageFile) return;
      this.uploadingImage = true;
      const fd = new FormData();
      fd.append('image', this.imageFile);

      forumService.uploadAuthorImage(fd).then(res => {
        this.myAuthor = res.data.author;
        this.showMsg('Imagen actualizada', 'success');
        this.dialogImage = false;
        this.imageFile = null;
      }).catch(() => {
        this.showMsg('Error al subir imagen', 'error');
      }).finally(() => {
        this.uploadingImage = false;
      });
    },
    asignarCategorias(admin) {
      if (!admin.forum_author) {
        this.showMsg('Este admin no tiene perfil de autor', 'error');
        return;
      }
      forumService.assignAuthorCategories(admin.forum_author.id, admin.selectedCategories).then(() => {
        this.showMsg('Categorías asignadas a ' + admin.name, 'success');
      }).catch(() => {
        this.showMsg('Error al asignar categorías', 'error');
      });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
